export const copy = window['__INITIAL_STATE__'].copy?.form.fields || null
